import { Dialog, DialogContent, DialogTitle, Radio } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import Button from "../../components/common/Button.tsx";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RiPlayLargeLine } from "react-icons/ri";

interface DataSourceModalProps {
    open: boolean;
    setOpen: any;
}

const DatasourceModal: React.FC<DataSourceModalProps> = ({ open, setOpen }) => {
    const [selectedDatasource, setSelectedDatasource] = useState("file");
    const navigate = useNavigate();
    const handleCloseModal = () => {
        setOpen(false)
    }
    const handleContinue = () => {
        navigate("/UploadDataSet", {
            state: {
                datasource: selectedDatasource
            }
        })
    }
    return (
        <>
            <Modal
                backdrop="static"
                centered={true}
                toggle={handleCloseModal}
                isOpen={open}
                className="rv-modal"
            >
                <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
                    File Upload Method
                    <button
                        type="button"
                        className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
                        onClick={handleCloseModal}
                    >
                        &times;
                    </button>
                </ModalHeader>
                <ModalBody className="fs-5 fw-bold text-center d-block">
                    Select any one method to continue.
                    <div className="d-flex justify-content-around align-items-center mt-4">
                        <div
                            className="d-flex align-items-center"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSelectedDatasource("file")}
                        >
                            <Radio
                                checked={selectedDatasource === "file"}
                                onChange={() => setSelectedDatasource("file")}
                                value="file"
                                name="selectedDatasource"
                                sx={{
                                    color: "#FD7545",
                                    '&.Mui-checked': {
                                        color: "#FD7545",
                                    },
                                }}
                            />
                            <p className="mb-0 fw-semibold fs-5">File Upload</p>
                        </div>

                        <div
                            className="d-flex align-items-center"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSelectedDatasource("datalake")}
                        >
                            <Radio
                                checked={selectedDatasource === "datalake"}
                                onChange={() => setSelectedDatasource("datalake")}
                                value="datalake"
                                name="selectedDatasource"
                                sx={{
                                    color: "#FD7545",
                                    '&.Mui-checked': {
                                        color: "#FD7545",
                                    },
                                }}
                            />
                            <p className="mb-0 fw-semibold fs-5">Connect to Datalake</p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center align-items-center pt-1 pb-2">
                    <div className="d-flex flex-row gap-3">
                        <Button
                            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                            onClick={handleContinue}
                        >
                            <i className="ri-arrow-right-s-line ri-2x label-icon align-middle me-1"></i>
                            {/* <RiPlayLargeLine size={16} /> */}
                            <span className="ps-3 px-2 ms-2 me-1 modal-btn">Continue</span>
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default DatasourceModal;